export const SectionSystemFolderTitles = {
    ActsOS: 'Акты СМР',
    ActsIS: 'Акты испытаний',
    Kips: 'КИПС',
    WorkProductionPlan: 'Проект производства работ (ППР)',
    TechnologicalMap: 'Технологические карты',
    InstrumentVerificationList: 'Перечень приборов с проверкой',
    Licenses: 'Лицензии'
} as const;

export const ROOT_SYSTEM_FOLDER_TITLES: string[] = Object.values(SectionSystemFolderTitles);

export const ACT_CONTAINER_TITLES: string[] = [SectionSystemFolderTitles.ActsOS, SectionSystemFolderTitles.ActsIS];

export const SUBSECTION_DOC_FOLDER_TITLES: string[] = [
    'Исполнительные схемы',
    'Протоколы испытаний',
    'Документы, подтверждающие качество и безопасность материалов',
    'Специальные журналы'
];

export const FIRE_SAFETY_FOLDER_TITLES: string[] = [
    SectionSystemFolderTitles.Kips,
    SectionSystemFolderTitles.WorkProductionPlan,
    SectionSystemFolderTitles.TechnologicalMap,
    SectionSystemFolderTitles.InstrumentVerificationList,
    SectionSystemFolderTitles.Licenses
];

export const ALL_SYSTEM_FOLDER_TITLES: string[] = [...ROOT_SYSTEM_FOLDER_TITLES, ...SUBSECTION_DOC_FOLDER_TITLES];